"use client";
import type { TextUIPart, ToolInvocationUIPart } from "@ai-sdk/ui-utils";
import type { UIMessage } from "ai";
import { ParsedToolInovcation } from "./AIMessageParser";
import RiverLoading from "~/components/themed/RiverLoading";

type Props = {
    input: string;
    messages: UIMessage[];
    toolInvocations: ParsedToolInovcation[];
    isCreatingEvent: boolean;
};

export const AIOutput = ({
    messages,
    input,
    toolInvocations,
    isCreatingEvent,
}: Props) => {
    if (isCreatingEvent) {
        return (
            <div className="stretch mx-auto flex w-full max-w-md flex-col flex-col items-center py-6">
                <span className="bold animate-pulse text-xl italic text-white">
                    Creating your event with AI...
                </span>
                <RiverLoading />
            </div>
        );
    }
    return (
        <div className="stretch mx-auto flex w-full max-w-md flex-col py-6">
            {messages.map((message) => (
                <div
                    key={message.id}
                    className="mb-4 whitespace-pre-wrap rounded p-3"
                >
                    <div className="mb-1 font-semibold">
                        {message.role === "user" ? "User: " : "AI: "}
                    </div>
                    {message.parts.map((part, i) => {
                        switch (part.type) {
                            case "text":
                                return (
                                    <Text
                                        key={`${message.id}-${i}`}
                                        part={part}
                                    />
                                );
                            case "tool-invocation":
                                return (
                                    <ToolInvocation
                                        key={`${message.id}-${i}`}
                                        part={part}
                                    />
                                );
                        }
                    })}
                </div>
            ))}
        </div>
    );
};

const Text = ({ part }: { part: TextUIPart }) => {
    return <div>{part.text}</div>;
};

const ToolInvocation = ({ part }: { part: ToolInvocationUIPart }) => {
    return <pre>{JSON.stringify(part.toolInvocation, null, 2)}</pre>;
};
